<template>
	<div class="form-group mb-2">
        <b-row>
            <b-col cols="12">
                <label class="mb-0">{{$t(data.label)}} <span class="text-danger">*</span></label>
                <div v-if="status==2" class="d-flex align-items-center">
                    <span :class="'text-'+text_status.toLowerCase()">{{$t(text_status)}}</span>
                    <popupRejectInfo :list="reject_list"></popupRejectInfo>
                </div>
            </b-col>
            <b-col cols="12">

                <div class="photo-wrapper rounded text-center">
                    <div v-if="status==1">
                        <a :href="image" target="_blank" class="btn btn-outline-grey fz-16 fw-300 m-0 d-flex align-items-center justify-content-center w-100">
                            <img :src="`${publicPath}/img/rcp/icon/preview.png`" class="mr-1">
                            <span>{{ $t('View Document') }}</span>
                        </a>
                    </div>
                    <div v-else-if="image && status!=1" class="position-relative d-inline-block">
                        <img :src="image" class="doc_image">
                        <button type="button" class="btn-remove" @click="removeImage()" v-if="!is_disabled">x</button>
                    </div>
                    <div v-else-if="status!=1">
                        <div v-if="isBorwse" class="d-flex align-items-center justify-content-center">
                            <!-- <button type="button" class="btn btn-outline-grey fz-16 fw-300 d-flex align-items-center justify-content-center w-100" @click="toggleCamera()" :disabled="is_disabled">
                                <img :src="`${publicPath}/img/rcp/icon/take-photo.png`" class="mr-1" width="24">
                                <span>Take Photo</span>
                            </button>
                            <div class="p-2">OR</div> -->
                            <div class="btn-choose-photo border-0 m-0 p-0 w-100">
                                <button type="button" class="btn btn-outline-grey fz-16 fw-300 m-0 d-flex align-items-center justify-content-center w-100" :disabled="is_disabled">
                                    <img :src="`${publicPath}/img/rcp/icon/solar_gallery-add-bold.png`" class="mr-1">
                                    <span>{{ $t('Browse') }}</span>
                                </button>
                                <FileComponent @file-updated="captureFile($event)" :key="'file_'+data.type"></FileComponent>
                            </div>
                        </div>
                        <!-- <div v-else>
                            <button type="button" class="btn btn-outline-grey fz-16 fw-300 d-flex align-items-center justify-content-center w-100" @click="toggleCamera()" :disabled="is_disabled">
                                <img :src="`${publicPath}/img/rcp/icon/take-photo.png`" class="mr-1" width="24">
                                <span>{{ $t('Take Photo') }}</span>
                            </button>
                        </div> -->
                    </div>
                    
                    <div v-if="error" class="invalid-feedback d-block mb-3">
                        {{$t(error)}}
                    </div>
                </div>
            </b-col>
        </b-row>
    </div>
</template>
<script>

import FileComponent from "@/components/FileComponent";
import popupRejectInfo from "@/components/popupRejectInfo";

  export default {
    name: 'kyc-file',
    data() {
      return {
        publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
        image:'',
        error:'',
        status:null,
        text_status:'',
        is_disabled:false,
        reject_list:[]
      }
    },
    props: ['data','category','index','isBorwse'],
    components:{
        FileComponent,
        popupRejectInfo
    },
    methods:{
        setStatus(status,rejected_code){
            this.status = status;
            if(this.status == 0 || this.status == 1){
                this.is_disabled = true;
            }

            this.text_status = (this.status==0)?"Pending":(this.status==1?"Approved":"Rejected");

            if(status == 2){
                this.reject_list=rejected_code;
            }
        },
        captureFile($event){
            this.image = $event.previewBase64;
            const data = {category:this.category,index:this.index,file:this.image};
            this.error="";
            this.$emit('capture-file',data);
        },
        removeImage(){
            this.image = '';
            const data = {category:this.category,index:this.index};
            this.$emit('remove-image',data);
        },
        toggleCamera(){
            const data = {category:this.category,index:this.index,ref:"file_"+this.data.type};
            this.$emit('toggle-camera',data);
        }
    },
    mounted(){
        
    }
  };
</script>
